import Vue from 'vue'
import {
  itemTotal,
  shippingTotal,
  promotionTotal,
  promotionCode,
  taxLines,
  taxTotal,
  totalWithoutStoreCreditsUsed,
  total,
} from '@/stores/order'

export default {
  namespaced: true,
  state: {
    ordersByOrderNumber: {},
  },
  mutations: {
    addOrder(state, order) {
      Vue.set(state.ordersByOrderNumber, order.number, order)
    },
  },

  getters: {
    getOrderByNumber: state => orderNumber => state.ordersByOrderNumber[orderNumber],
    getShippingAddress: (state, getters) => orderNumber =>
      getters.getOrderByNumber(orderNumber)?.shippingAddress || {},
    getBillingAddress: (state, getters) => orderNumber =>
      getters.getOrderByNumber(orderNumber)?.billingAddress || {},
    getEmail: (state, getters) => orderNumber => getters.getOrderByNumber(orderNumber)?.email || '',
    getFirstname: (state, getters) => orderNumber =>
      getters.getOrderByNumber(orderNumber)?.shippingAddress?.firstname || '',
    getSelectedShippingMethod: (state, getters) => orderNumber =>
      getters.getOrderByNumber(orderNumber)?.shippingRates?.find(obj => obj.selected) || {},
    getItems: (state, getters) => orderNumber => getters.getOrderByNumber(orderNumber)?.items || [],
    getItemTotal: (state, getters) => orderNumber => itemTotal(getters.getItems(orderNumber)),
    isExcludedFromStoreCredits: (state, getters) => orderNumber =>
      getters.getOrderByNumber(orderNumber)?.isExcludedFromStoreCredit || false,
    getUsedStoreCredit: (state, getters) => orderNumber =>
      getters.getOrderByNumber(orderNumber)?.storeCreditTotalApplicable || 0,
    getHasUsedStoreCredit: (state, getters) => orderNumber =>
      getters.getUsedStoreCredit(orderNumber) > 0,
    getTotalRemainingStoreCredit: (state, getters) => orderNumber =>
      getters.getOrderByNumber(orderNumber)?.storeCreditTotalAvailable || 0,
    getShippingTotal: (state, getters, rootState, rootGetters) => orderNumber =>
      shippingTotal(
        getters.getItems(orderNumber),
        rootGetters['store/shippingThreshold'],
        rootGetters['store/shippingCost'],
        rootGetters['store/shippingCostAboveThreshold'],
        rootGetters['store/shippingCostBelowThreshold'],
        getters.getOrderByNumber(orderNumber)?.shippingRates?.find(obj => obj.selected)
      ),
    isCyclon: (state, getters) => orderNumber =>
      getters.getOrderByNumber(orderNumber)?.isCyclon || false,
    getPromotionTotal: (state, getters) => orderNumber =>
      promotionTotal(getters.getOrderByNumber(orderNumber)?.promotionAdjustment),
    getPromotionCode: (state, getters) => orderNumber =>
      promotionCode(getters.getOrderByNumber(orderNumber)?.promotionAdjustment),
    getTaxLines: (state, getters) => orderNumber =>
      taxLines(getters.getOrderByNumber(orderNumber)?.taxAdjustments),
    getTaxTotal: (state, getters) => orderNumber =>
      taxTotal(
        getters.getOrderByNumber(orderNumber)?.taxAdjustments,
        getters.getOrderByNumber(orderNumber)?.isTaxIncluded
      ),
    getTotalWithoutStoreCreditsUsed: (state, getters) => orderNumber =>
      totalWithoutStoreCreditsUsed(
        getters.getItemTotal(orderNumber),
        getters.getShippingTotal(orderNumber),
        getters.getPromotionTotal(orderNumber),
        getters.getTaxTotal(orderNumber),
        getters.getOrderByNumber(orderNumber)?.isTaxIncluded,
        getters.getOrderByNumber(orderNumber)?.canShowTaxLines
      ),
    getTotal: (state, getters) => orderNumber =>
      total(
        getters.getTotalWithoutStoreCreditsUsed(orderNumber),
        getters.getUsedStoreCredit(orderNumber),
        getters.isExcludedFromStoreCredits(orderNumber)
      ),
  },
}
